import { useState } from 'react';
import InfiniteScroll, {
  Props as InfiniteScrollProps,
} from 'react-infinite-scroll-component';
import { useDebounce } from 'react-use';
import { IconButton, Stack, TextField, TextFieldProps } from '@mui/material';

import { CloseCircleIcon, SearchIcon } from '~assets/icons';

interface Props extends InfiniteScrollProps {
  onSearching?: (searchString: string) => void;
  onInputValueChange?: (value: string) => void;
  optionsOpen?: boolean;
  itemHeight?: number;
  maxItemShow?: number;
  textFieldProps?: TextFieldProps;
}

export const AsyncListWithSearch: React.FC<Props> = ({
  onSearching,
  onInputValueChange,
  optionsOpen = true,
  textFieldProps,
  children,
  ...props
}) => {
  const [inputValue, setInputValue] = useState('');

  const onInputChange = (value: string) => {
    setInputValue(value);
    onInputValueChange && onInputValueChange(value);
  };

  useDebounce(
    () => {
      onSearching && onSearching(inputValue);
    },
    500,
    [inputValue],
  );

  // Clear input value handler
  const handleClearInput = () => {
    setInputValue('');
    onInputValueChange && onInputValueChange('');
  };

  return (
    <>
      <TextField
        value={inputValue}
        onChange={(e) => onInputChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <Stack marginLeft={1} marginRight={0.5}>
              <SearchIcon />
            </Stack>
          ),
          endAdornment: inputValue ? (
            <IconButton
              onClick={handleClearInput}
              edge="end"
              size="small"
              sx={{ marginRight: '0.5rem' }}
            >
              <CloseCircleIcon />
            </IconButton>
          ) : null,
          sx: {
            borderRadius: '100px',
            padding: '5px 0 !important',
          },
        }}
        inputProps={{
          sx: {
            padding: '7px 4px',
          },
          autoComplete: 'off',
        }}
        {...textFieldProps}
      />
      {optionsOpen && (
        <Stack overflow="scroll">
          <InfiniteScroll {...props}>{children}</InfiniteScroll>
        </Stack>
      )}
    </>
  );
};
